import type {
  AUTHENTICATION_METHOD,
  BACKGROUND_TYPES,
  EXCLUDE,
  FILLING_TYPES,
  LOGIN_POSITIONS,
} from 'common/constants/Constants';

/**
 * 全局通用的类型
 * */
export enum PersonVerify {
  mobile = 'mobile',
  weChat = 'wechat',
}

/** 应用类型 */
export enum APP_TYPE {
  /** oneid */
  ONEID = 'toa',
  /** 腾讯会议 */
  MEETING = 'meeting',
  /** 腾讯文档 */
  DOC = 'doc',
  /** 搜狗输入法 */
  SOGOUINPUT = 'sogouinput',
  /** 元宝 */
  YUANBAO = 'yuanbao-biz',
}

/** 用户信息 */
export interface IUserInfo {
  /** 企业下的用户信息 */
  accountUser: {
    adminForbidden: string;
    name: string;
    avatarUrl: string;
    isCreator: boolean;
    username: string;
    unionId: string;
    aliasId: string;
    units: string[];
    passwordInitialized: boolean;
    fuzzyMobile: string;
    isPasswordSet: boolean;
    mobile: string;
    email: string;
    employeeNo: string;
    emailAccount: string;
    joinTime: string;
    position: string;
    isEmailPasswordSet: boolean;
  };
  /** 用户信息 */
  user: {
    fuzzyMobile: string;
    isCreator: boolean;
    isPasswordSet: boolean;
    isWeComBound: boolean;
    weChat: string;
    personVerify?: PersonVerify[];
  };
  authenticationMethod: AUTHENTICATION_METHOD | undefined;
  personStatus: string;
}

/** 企业信息 */
export interface IAccount extends IResponseType {
  domain: string;
  accountId: string;
  accountType: number;
  /** 后端数据上该参数与版本点sso的type=10相同，
   * 版本规划基于灰度企业新权限系统，为了兼容非灰度企业，
   * 版本规划前使用ssoSwitch进行权限控制的地方依旧使用ssoSwitch进行版本控制，不替换成版本点
   */
  ssoSwitch: boolean;
  logoUrl: string;
  name: string;
  sourceName: string;
  usernameStatus: string;
  domainModified: boolean;
  nameUpdateAt: number;
  nameCanChange: boolean;
  emailDomains: string[];
  account_version: string;
  uin: string;
  enterpriseSize: string;
  industryType: string;
  certifyStatus: number;
  certifyMsg: string;
  certifyCompleteTime: string; // 企业认证成功时间
}

export interface IBrands {
  position: LOGIN_POSITIONS;
  backgroundType: BACKGROUND_TYPES;
  imageUrl: string;
  fillingType: FILLING_TYPES;
  color: string;
  customCssEnabled: boolean;
  css: string;
  template: string;
  id?: string;
}

export type TCaptchaOption =
  | { ticket: string; randStr: string }
  | { sessionId: string; sig: string; token: string };
export type TCaptchaOptions = {
  appId: string;
  cloudType: string;
  appKey: string;
  scene: string;
};

export enum IDENTITY_TYPE {
  GOVWECHAT_V0 = 'GOVWECHAT_V0', // 私有化企业微信
  OIDC = 'OIDC_V0',
  SAML = 'SAML2_V1',
  SAML_LEGACY = 'SAML2_V0',
  WEWORK = 'WEWORK_V1', // TODO：废弃，暂时不可删除防止idp中报错
  WEWORK_V0 = 'WEWORK_V0', // 微信？
  WEWORK_V2 = 'WEWORK_V2', // 企业微信
  LARK = 'FEISHU_V0',
  AD = 'AD_V1',
  DINGTALK = 'DINGTALK_V0',
  CAS = 'CAS_V0',
  OAUTH2 = 'OAUTH2_V0',
  PASSWORD = 'PASSWORD_V0', // 用户名密码
  JWT = 'JWT_V0',
  OPENLDAP = 'OPENLDAP_V1',
  /** 数据源AAD */
  AAD = 'AAD_V0',
  /** 认证源AAD */
  AAD_SAML = 'AAD_SAML_V0',
}

export interface IResetPasswordUrlParams {
  reset_token: string;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export type IResponseType<TData = Record<string, any>> = TData & {
  errCode?: string;
  errMessage?: string;
  data?: TData;
};

export interface IUploadImgRes {
  url: string;
  cos_id: string;
}

export enum INVITATION_STATUS {
  INIT,
  ENABLED,
  DISABLED,
}
export type TExpireCond = {
  expire_day: number;
  expire_at: number;
};

export type TInvitationProfile = {
  url: string;
  invitation_code: string;
  qr_code: string;
};

export type TInv = {
  invitation_id: string;
  sharding_id: string;
  status: INVITATION_STATUS;
  expire_condition: TExpireCond;
  approval_flag: number;
};

export type TProfile = {
  profile_id: string;
  profile: TInvitationProfile;
};

export type TInvitationInfo = {
  inv: TInv;
  profile: TProfile;
};

export interface IInvitation {
  invitation: TInvitationInfo;
  app_txt: string;
  department: { name: string };
}

export interface IPolicy {
  minLength: number;
  maxLength: number;
  minNumber: number;
  minSymbol: number;
  minLowerCase: number;
  minUpperCase: number;
  exclude: EXCLUDE[];
}

// 滑块验证结果保证安全的一个临时session
export interface ICaptchaSession {
  verify_session_id?: string;
  next?: {
    captchaOptions?: {
      options?: any[];
    };
  };
  expire?: number;
  state?: string;
  mobile?: string; // 滑块验证，发短信的手机号，前端自己填写，无需后端返回
}
